import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaidarshancabs() {



    const cardData = {




keyword: "Mumbai Darshan Cabs",

headingDescription: "Shreesha Tours & Travels offers reliable and affordable Mumbai Darshan cab services with customized sightseeing packages for families, couples, tourists, corporate groups, senior citizens, and international visitors. We provide half-day, full-day, and customized Mumbai city tour packages with experienced chauffeurs who are familiar with all major attractions and tourist routes. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for individuals as well as large groups. With doorstep pickup from hotels, homes, airports, railway stations, and cruise terminals, transparent pricing, flexible itineraries, and 24/7 customer support, Shreesha Tours & Travels ensures a comfortable and memorable sightseeing experience. Whether you want to explore Mumbai's historical landmarks, religious places, beaches, museums, shopping destinations, or iconic film city attractions, our Mumbai Darshan cab service provides clean vehicles, courteous drivers, and a hassle-free journey to all major attractions in the city.",

topPlaces: [
  {
    title: "Gateway of India",
    description: "Gateway of India is Mumbai's most iconic monument overlooking the Arabian Sea. Built in 1924, this historic landmark is a must-visit attraction and serves as the departure point for ferry rides to the famous Elephanta Caves."
  },
  {
    title: "Marine Drive",
    description: "Marine Drive, popularly known as the Queen's Necklace, is one of Mumbai's most beautiful seafront promenades. Visitors enjoy scenic Arabian Sea views, spectacular sunsets, and the dazzling city skyline illuminated at night."
  },
  {
    title: "Elephanta Caves",
    description: "A UNESCO World Heritage Site, the Elephanta Caves are famous for their ancient rock-cut temples and magnificent sculptures dedicated to Lord Shiva. The caves are accessible by ferry from the Gateway of India."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Shree Siddhivinayak Ganpati Temple is one of India's most revered temples dedicated to Lord Ganesha. Thousands of devotees visit every day to seek blessings and experience its peaceful spiritual atmosphere."
  },
  {
    title: "Haji Ali Dargah",
    description: "Located on a small island in the Arabian Sea, Haji Ali Dargah is one of Mumbai's most famous religious landmarks. The beautiful white marble shrine attracts visitors from all faiths throughout the year."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is one of Mumbai's most popular beaches, famous for its lively atmosphere, delicious street food, horse rides, and beautiful sunset views. It is a favorite destination for families and tourists."
  },
  {
    title: "Bandra Bandstand",
    description: "Bandra Bandstand is a scenic waterfront promenade offering breathtaking sea views, Bandra Fort, and the residences of several Bollywood celebrities. It is a popular destination for evening walks and photography."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus (CSMT) is admired for its magnificent Victorian Gothic architecture and is one of Mumbai's most recognized historical landmarks."
  },
  {
    title: "Sanjay Gandhi National Park",
    description: "Sanjay Gandhi National Park is one of the world's largest urban national parks, featuring lush forests, wildlife, safari rides, trekking trails, and the ancient Kanheri Caves."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is Mumbai's famous shopping and dining destination offering fashion boutiques, handicrafts, jewelry, cafés, restaurants, and vibrant street markets, making it a perfect stop during a Mumbai Darshan tour."
  }
],



"services": [
  {
    "name": "Mumbai Darshan Cab",
    "description": "Book Mumbai Darshan Cab for a comfortable and memorable city sightseeing experience with professional chauffeurs and well-maintained AC vehicles. Visit famous attractions including Gateway of India, Marine Drive, Haji Ali Dargah, Siddhivinayak Temple, Juhu Beach, Bandra Bandstand, Hanging Garden, Chhatrapati Shivaji Maharaj Terminus, Colaba, and other popular tourist destinations with flexible half-day and full-day sightseeing packages."
  },
  {
    "name": "Mumbai Darshan Taxi",
    "description": "Hire Mumbai Darshan Taxi for convenient sightseeing with experienced drivers who are familiar with the city's top tourist attractions. Travel comfortably in Sedan, Ertiga, Innova Crysta, SUV, or Tempo Traveller vehicles for family holidays, corporate outings, and tourist visits with flexible travel schedules."
  },
  {
    "name": "Mumbai Darshan Cab Service",
    "description": "Choose Mumbai Darshan Cab Service for safe, reliable, and affordable city tours with chauffeur-driven vehicles. Enjoy personalized sightseeing itineraries, comfortable travel, and convenient pickup and drop services while exploring Mumbai's iconic landmarks, beaches, temples, museums, shopping areas, and historical attractions."
  },
  {
    "name": "Mumbai Darshan Tour Package",
    "description": "Book Mumbai Darshan Tour Package for a complete sightseeing experience covering the city's most famous attractions in a single trip. Enjoy affordable packages, professional drivers, comfortable vehicles, and customized itineraries suitable for families, couples, solo travelers, and corporate groups."
  },
  {
    "name": "Mumbai Sightseeing Cab",
    "description": "Reserve Mumbai Sightseeing Cab for hassle-free travel across Mumbai with experienced chauffeurs, clean AC vehicles, and flexible travel plans. Visit popular tourist attractions, beaches, temples, shopping destinations, and cultural landmarks comfortably throughout the day."
  },
  {
    "name": "Mumbai Local Sightseeing Taxi",
    "description": "Choose Mumbai Local Sightseeing Taxi for convenient city exploration with reliable drivers, affordable fares, and comfortable vehicles. Perfect for tourists, families, business visitors, and weekend travelers looking to discover Mumbai's famous attractions."
  },
  {
    "name": "Mumbai City Tour Cab",
    "description": "Book Mumbai City Tour Cab for a complete guided city tour with professional chauffeurs and premium vehicles. Enjoy a comfortable journey covering heritage sites, famous beaches, religious places, museums, shopping streets, and scenic viewpoints across Mumbai."
  },
  {
    "name": "Mumbai Tourist Cab",
    "description": "Hire Mumbai Tourist Cab for safe and comfortable sightseeing with spacious vehicles, experienced drivers, and flexible pickup timings. Ideal for tourists visiting Mumbai for leisure, holidays, business trips, and family vacations."
  },
  {
    "name": "Mumbai Darshan Car Rental",
    "description": "Choose Mumbai Darshan Car Rental with chauffeur-driven vehicles for private sightseeing and personalized travel experiences. Select from Sedan, Ertiga, Innova Crysta, SUV, or Tempo Traveller according to your travel requirements and group size."
  },
  {
    "name": "Mumbai Full Day Cab Booking",
    "description": "Book Mumbai Full Day Cab Booking for unlimited city travel with dedicated chauffeur service, comfortable AC vehicles, and flexible sightseeing schedules. Explore Mumbai at your own pace with convenient pickup and drop facilities."
  },
  {
    "name": "Mumbai Darshan Taxi Package",
    "description": "Reserve Mumbai Darshan Taxi Package with affordable sightseeing plans, professional chauffeurs, and premium vehicles. Enjoy customized travel covering Mumbai's major tourist attractions with complete comfort and convenience."
  },
  {
    "name": "Mumbai Family Tour Cab",
    "description": "Book Mumbai Family Tour Cab for safe and spacious travel with comfortable seating, experienced drivers, and reliable service. Perfect for family vacations, children's outings, holiday tours, and sightseeing across Mumbai's famous attractions."
  },
  {
    "name": "Mumbai Gateway of India Cab",
    "description": "Hire Mumbai Gateway of India Cab for comfortable transportation to one of Mumbai's most iconic landmarks. Enjoy convenient pickup, professional drivers, and reliable travel for sightseeing, photography, and nearby tourist attractions."
  },
  {
    "name": "Mumbai Marine Drive Taxi",
    "description": "Choose Mumbai Marine Drive Taxi for comfortable travel to the famous Queen's Necklace and nearby attractions. Enjoy scenic drives, sunset views, flexible travel timings, and professional chauffeur service throughout your journey."
  },
  {
    "name": "Mumbai Airport to Mumbai Darshan Cab",
    "description": "Book Mumbai Airport to Mumbai Darshan Cab for direct airport pickup followed by a comfortable sightseeing tour of Mumbai. Enjoy timely airport transfers, experienced chauffeurs, clean AC vehicles, and customized city tour packages without any travel hassle."
  },
  {
    "name": "Mumbai Sightseeing Taxi Service",
    "description": "Choose Mumbai Sightseeing Taxi Service for reliable and comfortable city tours with trained chauffeurs, well-maintained vehicles, and affordable pricing. Explore Mumbai's top attractions, beaches, temples, historical monuments, shopping destinations, and cultural landmarks with flexible half-day and full-day sightseeing packages."
  }
],
"tableData": [
  ["Mumbai Darshan Cab", "Mumbai Darshan Taxi"],
  ["Mumbai Darshan Cab Service", "Mumbai Darshan Tour Package"],
  ["Mumbai Sightseeing Cab", "Mumbai Local Sightseeing Taxi"],
  ["Mumbai City Tour Cab", "Mumbai Tourist Cab"],
  ["Mumbai Darshan Car Rental", "Mumbai Full Day Cab Booking"],
  ["Mumbai Darshan Taxi Package", "Mumbai Family Tour Cab"],
  ["Mumbai Gateway of India Cab", "Mumbai Marine Drive Taxi"],
  ["Mumbai Airport to Mumbai Darshan Cab", "Mumbai Sightseeing Taxi Service"]
],




whychoose: [
  {
    WhyChooseheading: "Discover Mumbai with a Comfortable Mumbai Darshan Cab",
    WhyChoosedescription: "Explore the vibrant city of Mumbai with Shreesha Tours & Travels. Our Mumbai Darshan cab service is ideal for families, tourists, couples, corporate guests, and visitors who wish to experience the city's famous landmarks in comfort."
  },
  {
    WhyChooseheading: "Customized Sightseeing Tours at Your Own Pace",
    WhyChoosedescription: "Create your own Mumbai sightseeing itinerary by choosing the attractions you want to visit. Spend more time at your favourite destinations without the restrictions of fixed tour schedules."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Group Size",
    WhyChoosedescription: "Book Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses suitable for solo travellers, families, and large groups."
  },
  {
    WhyChooseheading: "Visit Mumbai's Iconic Attractions",
    WhyChoosedescription: "Enjoy convenient travel to Gateway of India, Marine Drive, Chhatrapati Shivaji Maharaj Terminus, Siddhivinayak Temple, Haji Ali Dargah, Bandra Bandstand, Juhu Beach, Hanging Garden, Elephanta Caves, Colaba Causeway, Worli Sea Link, and many more popular destinations."
  },
  {
    WhyChooseheading: "Friendly Drivers with Local City Knowledge",
    WhyChoosedescription: "Our experienced chauffeurs know the best city routes and sightseeing circuits, helping you enjoy a smooth journey while covering Mumbai's major attractions efficiently."
  },
  {
    WhyChooseheading: "Half-Day & Full-Day Mumbai Darshan Packages",
    WhyChoosedescription: "Choose from half-day city tours, full-day sightseeing packages, customized Mumbai Darshan trips, or private family tours based on your available time."
  },
  {
    WhyChooseheading: "Perfect for Tourists, Families & Corporate Guests",
    WhyChoosedescription: "Our Mumbai Darshan taxis are suitable for holiday travellers, business visitors with free time, school groups, senior citizens, and guests visiting Mumbai for the first time."
  },
  {
    WhyChooseheading: "Easy Mumbai Darshan Cab Booking",
    WhyChoosedescription: "Shreesha Tours & Travels offers transparent pricing, flexible sightseeing plans, and dependable customer support to make your Mumbai city tour comfortable and memorable."
  }
]

};

const faqData = [
  {
    question: "Which tourist places are covered in Mumbai Darshan?",
    answer: "Popular attractions include Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, Haji Ali Dargah, Bandra Bandstand, Hanging Garden, Worli Sea Link, CST, Colaba Causeway, and other famous landmarks."
  },
  {
    question: "Can I customize my Mumbai Darshan sightseeing route?",
    answer: "Yes, you can select the places you want to visit and customize the sightseeing itinerary according to your interests and available time."
  },
  {
    question: "Which vehicles are available for Mumbai Darshan?",
    answer: "Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses are available."
  },
  {
    question: "Do you offer half-day and full-day Mumbai Darshan packages?",
    answer: "Yes, both half-day and full-day sightseeing packages are available along with customized city tours."
  },
  {
    question: "Can families and senior citizens book a private Mumbai Darshan cab?",
    answer: "Yes, our private cabs provide comfortable sightseeing for families, children, senior citizens, and tourists of all ages."
  },
  {
    question: "Do you provide hotel and airport pickup for Mumbai Darshan?",
    answer: "Yes, pickup can be arranged from hotels, Mumbai Airport, railway stations, homes, and other preferred locations."
  },
  {
    question: "Are Tempo Travellers available for group sightseeing?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for school groups, corporate outings, family tours, and large sightseeing groups."
  },
  {
    question: "Can I include shopping destinations during the city tour?",
    answer: "Yes, shopping stops such as Colaba Causeway, Linking Road, Fashion Street, Crawford Market, and other markets can be added to your itinerary."
  },
  {
    question: "How is the Mumbai Darshan cab fare calculated?",
    answer: "The fare depends on the vehicle category, tour duration, number of sightseeing locations, and selected travel package."
  },
  {
    question: "How can I book a Mumbai Darshan Cab with Shreesha Tours & Travels?",
    answer: "Simply share your travel date, pickup location, preferred sightseeing places, passenger count, and vehicle choice to receive your quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Karthik Iyer",
    feedback: "Our Mumbai sightseeing tour was perfectly planned by Shreesha Tours & Travels. The driver covered all the major attractions comfortably, and the entire day was enjoyable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Bansal",
    feedback: "We booked an Innova Crysta for Mumbai Darshan with our family. The vehicle was spacious, the sightseeing itinerary was flexible, and the service was excellent from beginning to end.",
    rating: 5
  }
];

















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Darshan Cabs",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-darshan-cabs.webp",
  "description":
    "Book Mumbai Darshan Cabs with Shreesha Tours & Travels for safe, comfortable, and affordable sightseeing taxi services. We provide full-day and customized Mumbai Darshan packages with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for families, tourists, corporate guests, and groups visiting Gateway of India, Marine Drive, Siddhivinayak Temple, Juhu Beach, Bandra, and other popular attractions.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-darshan-cabs"
  }
};



    return (
        <div>

<Helmet>
  <title>Mumbai Darshan Cabs | Full Day Sightseeing Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai Darshan Cabs with Shreesha Travels for affordable Mumbai sightseeing taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for full-day city tours, family outings, and visits to Mumbai's top attractions with 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai Darshan Cab, Mumbai Darshan Taxi, Mumbai Darshan Cab Service, Mumbai Darshan Tour Package, Mumbai Sightseeing Cab, Mumbai Local Sightseeing Taxi, Mumbai City Tour Cab, Mumbai Tourist Cab, Mumbai Darshan Car Rental, Mumbai Full Day Cab Booking, Mumbai Darshan Taxi Package, Mumbai Family Tour Cab, Mumbai Gateway of India Cab, Mumbai Marine Drive Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/35.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaidarshancabs;